import { LocalizationProvider } from "@mui/x-date-pickers";
import { RouterProvider } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { getLocaleAdapterReducer } from "app/services/global/user-utils";
import { useAppLanguage } from "../generic-hooks/use-app-language";

import ROUTES from "app/AppRoutes";
import { useSession } from "app/hooks/useSession";
import { PageTitleProvider } from "app/providers/PageTitleProvider";
import TranslationProvider from "app/providers/TranslationProvider";
import { useMemo } from "react";
import i18n from "app/config/i18n";

const AppPostLoaderComponent = () => {
    const { data: userSession } = useSession();
    // Sync language with i18n
    const locale = useMemo(() => {
        return userSession?.preferredLanguage || i18n.resolvedLanguage || i18n.language;
    }, [userSession]);
    useAppLanguage(locale);

    return (
        <TranslationProvider language={locale}>
            <PageTitleProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getLocaleAdapterReducer(locale)}>
                    <RouterProvider router={ROUTES} />
                </LocalizationProvider>
            </PageTitleProvider>
        </TranslationProvider>
    );
}

export default AppPostLoaderComponent;
